import apiRequest from './handler';

const loanTypesService = {
    /**
     * Active loan types, as the backend defines them.
     *
     * The dashboard used to take its loan type vocabulary from a hardcoded
     * map, which is why products added after that map was written never
     * appeared. Reading the list here means retiring or adding a product is a
     * data change rather than a deploy.
     */
    getActiveLoanTypes: async (setIsAuthenticated, navigate) => {
        try {
            return await apiRequest(
                '/common/loan-types',
                'get',
                {},
                true,
                setIsAuthenticated,
                navigate
            );
        } catch (error) {
            console.error('Error fetching loan types:', error);
            throw error;
        }
    },
};

export default loanTypesService;
